// const shippingInfoButton = document.getElementById('shipping');
// const shippingInfoButtonTop = document.getElementById('shipping-top');
// const shippingInfoSlide = document.getElementById('shipping-info-slide');
// const shippingInfoSlideClose = document.querySelector('.closebtn')


// shippingInfoButton.addEventListener('click', () => shippingInfoSlide.classList.toggle('open'))
// shippingInfoButtonTop.addEventListener('click', () => shippingInfoSlide.classList.toggle('open'))
// shippingInfoSlideClose.addEventListener('click', () => shippingInfoSlide.classList.remove('open'))

// PDP Reviews - Duplicating the review summary and placing it under the price //


var reviewSummary = document.querySelector('.spr-container')

if (reviewSummary) {
    const reviewScores = document.querySelector('.spr-summary');
    const priceContainer = document.querySelector('.product-single__price')
    const reviewScoreClone = reviewScores.cloneNode(true);

    const topReviewContainer = document.createElement('a')

    priceContainer.appendChild(topReviewContainer)
    topReviewContainer.appendChild(reviewScoreClone);
    topReviewContainer.classList.add('top-review-container')

    const reviewActionAction = reviewScoreClone.querySelector('.spr-summary-actions')
    reviewActionAction.remove()

    topReviewContainer.addEventListener('click', () => {
        const reviewSection = document.getElementById('shopify-product-reviews')
        const reviewSectionTop = reviewSection.getBoundingClientRect().top + window.pageYOffset - 50
        window.scrollTo({ top: reviewSectionTop, behavior: 'smooth' })
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const paymentInfoWrapper = $('.payment-info__wrapper');
    if (jQuery('shopify-payment-terms')[0]) {
        
        setTimeout(function () {
            var paymentInfoTerms = $('shopify-payment-terms')
            var paymentInfoBanner = paymentInfoTerms[0].shadowRoot.querySelector('shop-pay-installments-banner');
            let textContainer = paymentInfoBanner.shadowRoot.getElementById('shopify-installments-content')

            textContainer.innerHTML = 'Slash Your Payments! ' + textContainer.innerHTML;
            paymentInfoWrapper.addClass('visible');
            
        }, 1500);
    }
});
